window.addEventListener("DOMContentLoaded" , () => {
	homeSliders();
});

var _resizeEvent;
window.addEventListener('resize' , () => {
	clearTimeout(_resizeEvent);
	_resizeEvent = setTimeout( () => {
		homeSliders();
		modalResize();
	} , 100);
});

/**
 * 動画の埋め込みと再生
 */

//768px以上
if(document.getElementById("homeVideoWide")) {
	videojs.getPlayer('homeVideoWide').ready( function() {
		const homeVideoWidePlayer = this;
		const $homeVideWide = document.querySelector(".home-hero-wide__video");
		const $volumeSwiching = document.querySelector(".home-hero-switching-wide");

		homeVideoWidePlayer.controlBar.hide();
		homeVideoWidePlayer.bigPlayButton.hide();
		homeVideoWidePlayer.muted(true);
		//自動再生
		homeVideoWidePlayer.on('loadedmetadata',function() {
			$homeVideWide.classList.add("is-acive");
			homeVideoWidePlayer.play();
		});
		//無限ループ
		homeVideoWidePlayer.on('ended',function() {
			homeVideoWidePlayer.play();
		});
		//音量のON・OFF機能
		$volumeSwiching.addEventListener("click" ,(event) =>{
			if( event.target.classList.contains("is-active") ) {
				homeVideoWidePlayer.muted(true);
				event.target.classList.remove("is-active");
				event.target.setAttribute("src" ,"/assets/img/home/icon_muted.png" )
			} else {
				homeVideoWidePlayer.muted(false);
				event.target.classList.add("is-active");
				event.target.setAttribute( "src" , "/assets/img/home/icon_unmuted.png" )
			}
		});
	});
};

/**
 * 767px以下の場合の処理
 */
const $homeSmartModal = document.querySelector(".home-hero-smart__modal");
const $smartVideoOpen = document.querySelector(".home-hero-smart-slides__nav__button");

//モーダルの高さのリサイズ
const modalResize = () => {
	const windowHeight = window.innerHeight;
	$homeSmartModal.style.height = `${windowHeight}px`;
}

//モーダルの表示と動画の再生
const homeSmartVideo = () => {
	const $smartVideoClose = document.querySelector(".home-hero-smart__modal__nav__close");
	const $smartVideoSwiching = document.getElementById("home-video-switching-smart");

	//動画の再生
	videojs.getPlayer('homeVideSmart').ready( function() {
		const windowHeight = window.innerHeight;
		$homeSmartModal.classList.add("is-opened");
		$homeSmartModal.style.height = `${windowHeight}px`;
		const homeVideoSmartPlayer = this;
		homeVideoSmartPlayer.muted(true); //ミュート
		homeVideoSmartPlayer.play();
		homeVideoSmartPlayer.controlBar.show();
		homeVideoSmartPlayer.bigPlayButton.hide();

		//無限ループ
		homeVideoSmartPlayer.on('ended',function() {
			homeVideoSmartPlayer.play();
		});

		//動画の音のON・OFFの切り替え
		$smartVideoSwiching.addEventListener( "click" , (e) => {
			swichingSound(e);
		});

		const swichingSound = (e) => {
			console.log( e.currentTarget.classList.contains("is-active") );
			let volumeFlag = e.currentTarget.classList.contains("is-active");
			if( volumeFlag ) {
				homeVideoSmartPlayer.muted(true);
				e.currentTarget.classList.remove("is-active");
				e.currentTarget.setAttribute("src" ,"/assets/img/home/icon_muted.png" );
				e.preventDefault();
			} else {
				homeVideoSmartPlayer.muted(false);
				e.currentTarget.classList.add("is-active");
				e.currentTarget.setAttribute( "src" , "/assets/img/home/icon_unmuted.png" );
				e.preventDefault();
			}
		}

		//モーダルを閉じる
		$smartVideoClose.addEventListener( "click" , ( e ) => {
			homeVideoSmartPlayer.pause();
			$homeSmartModal.classList.remove("is-opened");

			//音声がON場合はボタンをOFFの状態にする
			if($smartVideoSwiching.classList.contains("is-active")) {
				$smartVideoSwiching.classList.remove("is-active");
				$smartVideoSwiching.setAttribute( "src" , "/assets/img/home/icon_muted.png" );
			}
			e.preventDefault();
		});
	});
}
$smartVideoOpen.addEventListener("click", homeSmartVideo);

/**
 * ホームページに表示するスライダーの制御
 */
const homeSliders = () => {
	const windowSize = window.innerWidth;
	const pagerPosition = (thumbnail , button) => {
		const thumbHalfHeight = $(thumbnail).innerHeight() / 2;
		$(button).css("top", `${thumbHalfHeight}px`);
	};
	//端末解像度が767px以下の場合に表示するスライダー
	if(windowSize < 768 ) {
		const homeSmartHero = new Swiper ('.home-hero-smart-slides', {
			loop : true,
			centeredSlides: false,
			speed : 1000,
			autoplay: {
				delay: 5000,
				stopOnLastSlide: false,
				disableOnInteraction: false,
				reverseDirection: false
			},
			slidesPerView : 1,
			spaceBetween : 0,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
		});
	}

	//動画の直下のコンテンツ
	let homeHero = new Swiper ('.home-hero-slides', {
		loop : true,
		centeredSlides: false,
		slidesPerView: 4,
		spaceBetween : 32,
		speed: 1000,
		on : {
			init : () => {
				pagerPosition(".home-hero-slides__item__thumb", ".is-home-hero-button");
				$(".home-hero-slides").css("visibility","visible");
			},
			resize : () => {
				homeHero.destroy();
				homeHero = undefined;
				homeHero = new Swiper ('.home-hero-slides');
				pagerPosition(".home-hero-slides__item__thumb", ".is-home-hero-button");
			}
		},
		breakpoints: {
			767 : {
				slidesPerView : 1,
				spaceBetween : 0
			}
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev'
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		}
	});

	//Featured Stories
	// let homeStories = new Swiper ('.home-stories-slides', {
	// 	loop : true,
	// 	init : true,
	// 	slidesPerView : 2.5,
	// 	spaceBetween : 20,
	// 	loopAdditionalSlides: 5,
	// 	speed: 1000,
	// 	breakpoints: {
	// 		1024 : {
	// 			slidesPerView : 1.5,
	// 			spaceBetween : 20,
	// 		},
	// 		767 : {
	// 			slidesPerView : 1,
	// 			spaceBetween : 0
	// 		}
	// 	},
	// 	navigation: {
	// 		nextEl: '.swiper-button-next',
	// 		prevEl: '.swiper-button-prev'
	// 	},
	// 	pagination: {
	// 		el: '.swiper-pagination',
	// 		type: 'bullets',
	// 		clickable: true
	// 	},
	// 	on : {
	// 		init : () => {
	// 			pagerPosition(".home-stories-slides__item__thumb",".is-stories-button");
	// 			$(".home-stories-slides").css("visibility","visible");
	// 		},
	// 		resize : () => {
	// 			homeStories.destroy();
	// 			homeStories = undefined;
	// 			homeStories = new Swiper ('.home-stories-slides');
	// 			pagerPosition(".home-stories-slides__item__thumb",".is-stories-button");
	// 		}
	// 	},
	// });
}

//遅延表示の処理
const targets = document.querySelectorAll('.is-home-target');
const homeObserver = new IntersectionObserver( entries => {
	entries.forEach(entry =>{
		if (entry.intersectionRatio > 0) {
			entry.target.classList.add("is-ignition");
			homeObserver.unobserve(entry.target);
		}
	})
}, {
	rootMargin: '-100px 0px'
});
targets.forEach(target => {
	homeObserver.observe(target);
});
